export function sortbyOrderAscending(
  a: { name?: string; id?: number },
  b: { name?: string; id?: number },
) {
  const nameA = a.name ?? '';
  const nameB = b.name ?? '';

  return (
    nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' }) ||
    (a.id ?? 0) - (b.id ?? 0)
  );
}
